import { writable } from "svelte/store";
import type { V2PresentationOptions } from "../../common/types.ts";

export const v2Options = writable<V2PresentationOptions | undefined>(undefined);
